import { styled } from '@porsche-code/kado-styled-system/jsx';
import {
  ContentWrapper,
  Navigation,
  NavigationItem,
  NavigationLink,
  Header as StyledHeader,
} from '@porsche-code/kado-ui';
import kadoLogoSrc from '@porsche-code/kado-ui/icons/kado.svg';
import { Link, useMatchRoute } from '@tanstack/react-router';
import { signOut } from 'aws-amplify/auth';
import { useTranslation } from 'react-i18next';

import { NAMESPACES } from '@/config/i18n';
import { usePersonContext } from '@/context';

import { AdminNavigation } from './AdminNavigation';
import { SupportNavigationItem } from './SupportNavigationItem';

const Content = styled('div', {
  base: {
    alignItems: 'center',
    display: 'grid',
    gap: 'sm',
    gridTemplateColumns: '1fr auto',
  },
});

export const Header = () => {
  const { t } = useTranslation(NAMESPACES);
  const { state: personState } = usePersonContext();
  const matchRoute = useMatchRoute();

  const isPasswordFlowActive =
    process.env.REACT_APP_IS_PASSWORD_FLOW_ACTIVE === 'true';

  return (
    <header>
      <ContentWrapper>
        <StyledHeader />
        {personState.isAuthenticated && (
          <Content>
            <nav>
              <Navigation>
                <NavigationItem divider>
                  <NavigationLink iconSource={kadoLogoSrc}>
                    <Link to="/">{t('common:title')}</Link>
                  </NavigationLink>
                </NavigationItem>
                <NavigationItem>
                  <NavigationLink
                    isActive={!!matchRoute({ to: '/' })}
                    icon="none"
                  >
                    <Link to="/">{t('title')}</Link>
                  </NavigationLink>
                </NavigationItem>
                <NavigationItem>
                  <NavigationLink
                    isActive={!!matchRoute({ to: '/news', fuzzy: true })}
                    icon="none"
                  >
                    <Link to="/news">{t('featureArticles')}</Link>
                  </NavigationLink>
                </NavigationItem>
              </Navigation>
            </nav>
            <Navigation>
              {personState.isAuthorized && !personState.isAnonymous && (
                <>
                  <NavigationItem data-testid="profile">
                    <NavigationLink icon="user" hideLabel>
                      <Link to="/profile">{t('common:profile.headline')}</Link>
                    </NavigationLink>
                  </NavigationItem>

                  <SupportNavigationItem />

                  <AdminNavigation />
                </>
              )}

              {isPasswordFlowActive && (
                <NavigationItem>
                  <NavigationLink
                    onClick={async (event) => {
                      event.preventDefault();
                      await signOut();
                    }}
                    icon="logout"
                    aria-label={t('common:signOut')}
                    hideLabel
                  >
                    {t('common:signOut')}
                  </NavigationLink>
                </NavigationItem>
              )}
            </Navigation>
          </Content>
        )}
      </ContentWrapper>
    </header>
  );
};
